import { QueryConfig } from "store/utils/query-config";

export const checkListInstancesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
